import { Component, PaymentMethod } from '@cms-max/medicare-api-sdk'
import { Alert } from '@cmsgov/design-system'
import { ContentLayout } from 'components/Layouts'
import { useQueryParams } from 'hooks/useQueryParams'
import { useCompletePayment } from 'queries/premiums'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router'

export function MakeAPaymentProcessingPage () {
  const { t } = useTranslation('makeAPaymentProcessingPage')

  const { mutateAsync } = useCompletePayment()
  const queryParams = useQueryParams()
  const history = useHistory()

  // Various necessary query params that should have been added when Pay.gov redirects
  const paymentMethod = queryParams.get('paymentMethod')
  const agencyTrackingId = queryParams.get('agencyTrackingId')
  const tcsAppId = queryParams.get('tcsAppId')
  const token = queryParams.get('token')

  async function completePayment () {
    // If for some reason we don't have all the required query params, redirect to error page
    if (!paymentMethod || !token || !agencyTrackingId || !tcsAppId) {
      history.push('/premiums/make-a-payment/error?code=coreapi')
      return
    }

    try {
      const { isSuccess } = await mutateAsync({
        agencyTrackingId,
        tcsAppId,
        token
      })

      // If the payment fails, redirect to error page
      if (!isSuccess) {
        history.push(`/premiums/make-a-payment/error?code=paygov`)
        return
      }

      const completionQueryParams = new URLSearchParams({
        agencyTrackingId,
        tcsAppId
      }).toString()

      // Redirect to success page

      // Different routes/messages based on payment type
      if ([PaymentMethod.Cc, PaymentMethod.Hsa].includes(paymentMethod as PaymentMethod)) {
        history.push(`/premiums/make-a-payment/success?${completionQueryParams}`)
      } else {
        history.push(`/premiums/make-a-payment/submitted?${completionQueryParams}`)
      }
    } catch (error) {
      console.error('Error completing payment', error)

      history.push(`/premiums/make-a-payment/error?code=coreapi`)
    }
  }

  useEffect(() => {
    completePayment()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!paymentMethod || !agencyTrackingId || !tcsAppId || !token) {
    return null
  }

  return (
    <ContentLayout
      heading={t('heading')}
      width="wide"
      printComponent={Component.Premiums}
    >
      <div className="ds-l-container">
        <Alert variation="warn" heading={t('processingAlert.heading')} className="ds-u-measure--wide">
          {t('processingAlert.content')}
        </Alert>

        <div className='ds-u-margin-top--3'>
          <Skeleton height={40} width={314} />

          <Skeleton height={406} className='ds-u-margin-top--2' />

          <Skeleton height={44} width={221} className='ds-u-margin-top--5' />
        </div>
      </div>
    </ContentLayout>
  )
}
